const registration = {
  registration: {
    backButton: 'Back to Sign in',
    pageHeader: 'New User Registration',
    installerNote: 'Please reach out to your company/branch admin to create your User ID and invite you',
    registerOption: 'I want to register a new Solar Company with Enphase',
    installerOption: 'I am an installer working for a company that has already installed an Enphase system',
    doItYourselfOption: 'I am a do-it-yourself user installing Enphase products',
    homeownerOption: 'I am a homeowner',
    updateSignuppage: 'I agree that Enphase may contact me via calls and text messages at the phone number entered above for system information, upgrades, or marketing messages related to my system. These marketing calls and texts may be auto-dialed or generated by an artificial or pre-recorded voice. My consent to these communications is not a condition of any purchase and may be revoked at any time and by any reasonable means.',
    termsAndServices: 'I have read Enphase’s %{privacyPolicy} and have read and agree to the %{termsService}',
    termsServicesSafetyDisclaimer:
      'I acknowledge that I have read and agree to Enphase’s %{safetyDisclaimer}, %{privacyPolicy} and %{termsService}',
    safetyDisclaimer: 'Safety Disclaimer',
    accountHeader: 'Your account details',
    companyDetails: 'Company Details',
    firstName: 'First Name',
    lastName: 'Last Name',
    country: 'Country',
    email: 'Email',
    verificationHeader: 'Enter verification code',
    verificationNote: 'Enter the six digit verification code that was sent to %{email}',
    didntReceivedOtp: 'Didn’t receive verification code?',
    resendOtp: 'Resend verification code',
    setPasswordHeader: 'Set your Enlighten password',
    setPasswordNote:
      'Must be between 6 and 50 characters in length and contain at least 1 number or special character.',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    safetyDisclaimerNote:
      'Installation, service and maintenance of Enphase products should be performed only by qualified personnel. Electrical work must be performed by licensed electricians trained in the electrical code applicable to the region or territory, and knowledgeable about the legal requirements and safety considerations associated with solar, storage and energy management systems. Always refer to install manuals and guides.',
    fieldRequired: 'This field is required.',
    validEmail: 'Please enter a valid email address.',
    validPhone: 'Please enter a valid phone number.',
    validChamberNumber: 'Invalid Input! Minimum 8 characters required for Chamber of Commerce Number',
    companyName: 'Company Name',
    streetAddress: 'Street Address',
    streetAddress2: 'Street Address 2',
    city: 'City',
    state: 'State',
    zip: 'Zip/Postal Code',
    chamberofcommerce: 'Chamber Of Commerce Number',
    supportEmail: 'Customer Support Email',
    supportPhone: 'Customer Support Phone',
    wesbiteUrl: 'Website URL',
    companyLogo: 'Company Logo',
    chooseFile: 'Choose File',
    noFile: 'No file selected',
    chooseFileNote:
      'Must be a JPEG, GIF, or PNG file no larger than 4MB. For best results, we recommend a square image with a transparent background at least 400px wide by 400px tall.',
    enphaseInstaller: 'This company installs or plans to install Enphase Systems',
    privacyPolicy: 'Privacy Policy',
    termsService: 'Terms of Service',
    andText: 'and',
    accountNote: 'Note: Any systems added under this account will not be tagged to any installer for maintenance',
    phone: 'Phone',
    passwordMismatch: 'The passwords entered in the above fields should match with each other',
    updateSignupError: 'Please select the above checkbox to proceed with registration',
    privaryPolicyError:
      'If you do not agree to the terms of Enphase’s Privacy Policy and Terms of Service you may not register for Enlighten.',
    otpSuccess: 'Verification code resent successfully',
    registrationSuccess: 'Your Enlighten account has been created successfully',
    registrationSuccessRedirection: 'You have been successfully registered on Enlighten. Signing you in...',
    login: 'Login',
    warningName:
      'Warning: A company with this name already exists in the system. To ensure you get the right access, please reach out to your company/branch admin to create your user ID or contact Enphase Support.',
    errorName:
      'A company with this name already exists in the system. To ensure you get the right access, please reach out to your company/branch admin to create your user ID or contact Enphase Support.',
    warningAddress:
      'Warning: This address is associated with a company that already exists in the system. To ensure you get the right access, please reach out to your company/branch admin to create your user ID or contact Enphase Support.',
    errorSupportEmail:
      'This email ID is associated with a company that already exists in the system. To ensure you get the right access, please reach out to your company/branch admin to create your user ID or contact Enphase Support.',
    errorSupportPhone:
      'This phone number is associated with a company that already exists in the system. To ensure you get the right access, please reach out to your company/branch admin to create your user ID or contact Enphase Support.',
    warningUrl:
      'This website link is associated with a company that already exists in the system. To ensure you get the right access, please reach out to your company/branch admin to create your user ID or contact Enphase Support.',
    errorPhone:
      'This phone number is already associated with an existing account. Please use a different contact number or contact Enphase Support.',
    errorEmail:
      'This email address is already associated with an existing account. Please use a different email address or contact Enphase Support.',
    streetNumberEmptyError: 'Street number not found, please verify before saving.',
    recaptchaError: 'Please complete the reCAPTCHA verification to proceed.',
    infoText: 'Please ensure that marker is placed on the exact location.',
    warningText: 'Please ensure that you place the marker on the exact location.',
    locateMeText: 'Use the locate me button to get your current location.',
    addressCheckText: 'Ensure that you enter the correct address',
    markerText: 'Place the marker on the exact location',
    mapErrorText: 'Sorry! We were not able to locate you on Google Maps.'
  }
};

export default registration;
